<template>
	<div class="template_box">
		<div class="header">
			<h2 class="left_box">
				{{ CommentList.length }} {{ $t('MessagesArr.Comment')}} 
			</h2>
			<div class="right_box">
				<div class="menus" v-for="(menu, index) in menus" :key="menu.key" :class="{ active: activeMenu === menu.key }" @click="setActiveMenu(menu)">{{ menu.name }}</div>
			</div>
		</div>
		<div class="comment_list" v-if="CommentList.length > 0">
			<div class="comment_item" v-for="(item, index) in CommentList" :key="index" @click="comment_item(item)">
				<div class="comment_item_header">
					<div class="left_box">
						<div class="avatar" :class="if_routeName_home()  ? 'avatar_default' : 'avatar_pointer'" @click.stop="check_information(item)">
							<img v-if="item && item.avatar && item.avatar != ''" :src="item.avatar" :alt="'TOZO Community ' + item.nickname + ' User Avatar'"/>
							<i v-else class="el-icon-s-custom"></i>
						</div>
						<div class="comment_user_box">
							<div class="comment_user_name">{{ item.nickname }}</div>
							<div class="release_time">{{ $fun.formatTime(item.public_time) }}</div>
						</div>
					</div>
					<div class="right_box">
						<div class="more_relative">
							<div class="change_more" @click.stop="change_more(item)">
								<i class="el-icon-more-outline"></i>
							</div>
							<div class="choice_box" v-if="current_operation == item.comment_id" :class="current_operation == item.comment_id ? 'show_choice_box' : 'hidde_choice_box'">
								<div class="choice_list">
									<div class="choice_item" v-for="(c_item, c_index) in choice_list" v-if="if_current_user(item, c_item)" :key="c_index" @click.stop="post_operation(item, c_item)">{{ c_item.name }}</div>
								</div>
							</div>
						</div>
						<div class="thumb_num">{{ item.thumb }}</div>
						<div class="icon_box_img" @click.stop="give(item)">
							<img v-if="item.is_thumb == 1" src="../../assets/icon/comment_give.png" alt="TOZO thumb img">
							<img v-else src="../../assets/icon/comment_no_give.png" alt="TOZO thumb img">
						</div>
					</div>
				</div>
				
				<h3 class="comment_content" v-html="$fun.textWithLineBreaks(item.content)"></h3>
				<div class="comment_reply" @click.stop="View_replies(item)" v-if="item.reply">
					{{ $t('MessagesArr.View')}} {{ item.reply }} {{ $t('MessagesArr.replies')}}
					<i class="el-icon-arrow-right"></i>
				</div>
			</div>
		</div>
		
		<NoData v-else calling_modules="comment-module"></NoData>
		
		<CommentRepliesList v-if="view_comment_id" :view_comment_id="view_comment_id" @CancelReplyFun="CancelReplyFun"></CommentRepliesList>
		<ConfirmPrompt v-if="delpostItem != ''" :title="titlePrompt" @ConfirmFun="ConfirmFun" @CancelFun="CancelFun"></ConfirmPrompt>
		<RepliesAndComments v-if="contentBoxData" :contentBoxData="contentBoxData" @closureFun="closureFun"></RepliesAndComments>
	</div>
</template>

<script>

import CommentRepliesList from './CommentRepliesList.vue'
import { 
	post_community_postcomments, //帖子评论列表
	post_community_replycomments, //回复评论列表
	post_community_addcomment, //发布评论
	post_community_replycomment, //回复评论
	post_community_commentthumb, //点赞评论
	post_community_delcomment, //删除评论
	
	} from '@/api/community.js'
		export default {
			name: 'comment-list',
			components: { CommentRepliesList },

			props: {
				// Loading: {
				// 	type: Boolean,
				// 	default: false,
				// },
				calling_modules: {
					type: String,
					default: ""
				},
			}, 
			data() {
				return {
					menus: [
					  { key: "Heat", name: this.$t('CommentList.Heat'), type: 2 },
					  { key: "Time", name: this.$t('CommentList.Time'), type: 1  },
					],
					activeMenu: "Heat", // 默认选中菜单
					Loading: false,
					routeName: "",
					CommentList:[],
					post_search: {
						post_id: this.$route.params.post_id,
						sort_type: 2, //1： 按时间 2：按点赞量热度， 默认 ：2
					},
					post_page: {
						page: 1, 
						per_page: 10
					},
					reply_search: {
						comment_id: "",
						sort_type: 1, //1： 按时间 2：按点赞量热度， 默认 ：2
					},
					reply_page: {
						page: 1, 
						per_page: 10
					},
					view_comment_id: "",
					current_operation: "",
					
					choice_list:[
						{
							id: 1,
							type: "Reply",
							name: this.$t('CommentList.Reply'),
						},
						{
							id: 2,
							type: "Delete",
							name: this.$t('CommentList.Delete'),
						},
						{
							id: 3,
							type: "Copy",
							name: this.$t('CommentList.Copy'),
						},
						// {
						// 	id: 4,
						// 	type: "Cancel",
						// 	name: this.$t('CommentList.Cancel'),
						// }
					],
					delpostItem: "",
					titlePrompt: "",
					contentBoxData: "",
					show_more_icon: false,
				}
			},
			
		// 监听
			watch: {
				// "searchText": {
				// 	handler: function (newValue, oldValue) {
				// 		if(this.searchText && this.searchText != ''){
				// 			this.icon_search = false
				// 		}else{
				// 			this.icon_search = true
				// 		}
				// 	},
				// 	deep: true
				// },
			},
			
			// beforeCreate() {
				
			// }
			
			created () {
				
			},
		  
			mounted() {
				this.set_type_list()
				this.get_routeName()
				this.get_addEventListener()
			},
			
			methods: {
				//除了change_more按钮之外的点击事件都把current_operation收起
				get_addEventListener(){
					document.addEventListener('click', (e) => {
						const isMoreElement = e.target.closest('.change_more');
						if (!isMoreElement) {
						  this.current_operation = '';
						}
					});
				},
				
				//评论
				comment_item(item){
					if(!this.$store.state.userinfo.login_token){
						this.LoginTips()
						return
					}
					console.log(item)
					this.contentBoxData = {
						user_id: item.user_id,
						avatar: item.avatar,
						nickname: item.nickname,
						public_time: item.public_time,
						content: item.content,
						comment_id: item.comment_id,
						title: this.$t('MessagesArr.Reply_title'),
						type: "reply_to_comments"
					} 
				},
				
				//关闭评论
				closureFun(type){
					if(type == "success"){
						this.set_type_list()
					}
					this.contentBoxData = ''
				},
				
				// 判断是否是首页，首页才显示列表的关注按钮
				get_routeName(){
					this.routeName = this.$route.name;
					console.log(this.routeName)
				},
			
				// 判断是否是该用户本人的回复
				if_current_user(item, c_item){
					console.log(item.user_id)
					if(c_item.type == "Delete"){
						if(this.$store.state.userinfo.user_id == item.user_id){
							return true
						}else{
							return false
						}
					}else{
						return true
					}
					
				},
				
				if_routeName_home(){
					return this.routeName == 'users' || this.routeName == 'user-profile' || this.routeName == 'search-user'
				},
				
				//查看 粉丝或关注人信息
				// check_information(item){
				// 	console.log(item)
				// 	// 除了首页的帖子,个人列表页面和其他用户页面的列表不能进入个人列表页面
				// 	if(this.if_routeName_home()){ return }
				// 	this.$router.push({
				// 		name: "users",
				// 		params: {
				// 			user_id: item.user_id,
				// 			nickname: item.nickname,
				// 		}
				// 	})
				// },
				
				//查看 粉丝或关注人信息
				check_information(item){
					console.log(item)
					// 除了首页的帖子,个人列表页面和其他用户页面的列表不能进入个人列表页面
					if(this.if_routeName_home()){ return }
					
					let routeParams = {
						name: this.$store.state.userinfo.user_id == item.user_id ? "user-profile" : "users",
					   params: {
					      user_id: item.user_id,
					      nickname: item.nickname,
					   }
					};
					if (this.$route.name === 'home') {
						routeParams.params.previous = "posts-list";
					}else if (this.$route.name === 'users') {
						routeParams.name = "user-post-details"
						let path = this.$router.currentRoute.path
						let previous = path ? path.split("/")[1] : ''
						routeParams.params.previous = previous;
						
						let user = path ? path.split("/")[2] : ''
						if(user){
							routeParams.params.user = user;
						}
					}else{
						let path = this.$router.currentRoute.path
						let previous = path ? path.split("/")[1] : ''
						routeParams.params.previous = previous;
					}
					this.$router.push(routeParams);
				},
				
				//点击更多操作
				change_more(item) {
				   // 如果当前操作项和点击项相同
					if(item){
						if (this.current_operation === item.comment_id) {
						   // 切换显示状态
						   this.show_more_icon = !this.show_more_icon;
						   // 如果显示状态为 false，重置当前操作项
						   if (!this.show_more_icon) {
						      this.current_operation = '';
						   }
						} else {
						   // 如果当前操作项和点击项不同，设置当前操作项为点击项的 comment_id，并显示更多操作
						   this.current_operation = item.comment_id;
						   this.show_more_icon = true;
						}
					}else{
						this.current_operation = '';
						this.show_more_icon = true;
					}
				},
				
				//更多操作执行
				post_operation(item, Operation){
					if((Operation.type == "Reply" || Operation.type == "Delete") && !this.$store.state.userinfo.login_token){
						this.LoginTips()
						return
					}
					if(Operation.type == "Reply"){
						this.comment_item(item) //回复
					}else if(Operation.type == "Delete"){
						this.delpostItem = item
					}else if(Operation.type == "Copy"){
						this.Copy_comment(item) //复制
					}
					
					if(Operation.type == "Cancel"){
						this.current_operation = ''
					}else{
						let that = this
						setTimeout(()=>{
							that.current_operation = ''
						}, 200)
					}
				},
				
				//复制回复
				Copy_comment(item){
					if(!item.content){
						return this.$message('Copy failed', 'error')
					}
					let that = this
					let el = document.createElement("textarea");
					 el.value = item.content;
					 el.setAttribute("readonly", "");
					 el.style.position = "absolute";
					 el.style.left = "-9999px";
					 document.body.appendChild(el);
					 let selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
					 el.select();
					 document.execCommand("copy");
					 document.body.removeChild(el);
					 if (selected) {
						document.getSelection().removeAllRanges();
						document.getSelection().addRange(selected);
						that.$message('Copied', 'success')
					 }else{
						that.$message('Copy failed', 'error')
					 }
				},
				
				
				//确定删除回复
				ConfirmFun(item) {
				   this.post_community_delcomment(this.delpostItem) //删除
					this.delpostItem = ''
				},
				
				//取消删除回复
				CancelFun(){
					console.log(this.delpostItem)
					this.delpostItem = ''
				},
				
				//删除评论
				post_community_delcomment(item){
					console.log(item)
					post_community_delcomment({ comment_id: item.comment_id })
					.then((res) => {
						console.log(res)
						if(res.code == 0){
							this.set_type_list()
						}else{
							this.exception_handling(res, "delcomment")
						}
					})
					.catch((err) => {
						console.log(err)
						this.exception_handling(err, "delcomment")
					})
				},
				
				//查看回复
				View_replies(item){
					if(!this.$store.state.userinfo.login_token){
						this.LoginTips()
						return
					}
					this.view_comment_id = item.comment_id
				},
				
				// 关闭查看回复
				CancelReplyFun(){
					this.view_comment_id = ""
				},
				
				//点赞(帖子)
				give(item, status){
					this.change_more()
					if(!this.$store.state.userinfo.login_token){
						this.LoginTips()
						return
					}
					let obj = {
						comment_id: item.comment_id, 
						status: item.is_thumb == 0 ? 1 : 2, //is_thumb: 是否点赞, 0否, 1是, 1是,  //status：1点赞, 2取消
					}
					console.log(obj)
					post_community_commentthumb(obj)
					.then((res) => {
						console.log(res)
						if(res.code == 0){
							this.set_type_list()
						}else{
							this.exception_handling(res, "commentthumb")
						}
					})
					.catch((err) => {
						console.log(err)
						this.exception_handling(err, "commentthumb")
					})
				},
				
				// 类型切换
				setActiveMenu(menu) {
					if(this.activeMenu == menu.key){ return }
					this.activeMenu = menu.key; // 更新激活的菜单
					this.post_search.sort_type = menu.type; // 更新激活的菜单
					this.set_type_list()
				},
				
				// 根据类型获取数据
				set_type_list(){
					if(this.post_search.sort_type == 1){
						this.get_page_Data_postcomments(this.post_page)
					}else{
						this.get_page_Data_postcomments(this.post_page)
					}
				},
				
				
				// 获取分页 postcomments
				get_page_Data_postcomments(obj) {
					console.log(obj)
					if(obj && obj.page){
						this.post_page.page = obj.page
					}
					if(obj && obj.per_page){
						this.post_page.per_page = obj.per_page
					}
					this.post_community_postcomments(this.post_page)
				},
				
				//获取帖子评论列表
				post_community_postcomments(pageObj){
					if(this.Loading){ return }
					this.Loading = true
					let obj = {
						post_id: this.post_search.post_id, 
						sort_type: this.post_search.sort_type, 
						page: pageObj.page,
						per_page: pageObj.per_page
					}
					post_community_postcomments(obj)
					.then((res) => {
						console.log(res)
						if(res.code == 0){
							this.CommentList = res.data.data
							this.Loading = false
						}else{
							this.exception_handling(res, "postreport")
						}
					})
					.catch((err) => {
						console.log(err)
						this.exception_handling(err, "postreport")
					})
				},
				
				//浏览帖子
				post_community_postread(){
					let post_ids = [
						this.$route.params.post_id
					]
					post_community_postread({ post_ids: post_ids })
					.then((res) => {
						console.log(res)
						if(res.code == 0){
							console.log('预览上传成功')
						}else{
							this.exception_handling(res, "postread")
						}
					})
					.catch((err) => {
						console.log(err)
						this.exception_handling(err, "postread	")
					})
				},
				
				//异常处理
				exception_handling(err){
					this.Loading = false
					this.$errorMessage(err)
					// this.$message('err.data.message', 'error')
				},
				
				//子组件关注操作
				operations(type){
					if(type == 'success'){
						// 操作成功刷新列表数据
						this.set_type_list()
					}
				},
				
				LoginTips(){
					if(this.$IsConfirmExecute) { return }
					this.$IsConfirmExecute = true
					this.$MessageBox.confirm(
					   this.$t('ConfirmPrompt.experience_more'),
					   this.$t('ConfirmPrompt.Login_Tips'),
					   {
					      confirmButtonText: this.$t('buttonArr.Confirm'),
					      cancelButtonText: this.$t('buttonArr.Cancel'),
					      type: 'warning',
					   }
					).then((res) => {
						try {
						   // 用户点击了确认按钮
							console.log("用户点击了确认按钮")
							this.$router.replace({
								path: '/login',
								query: {
									redirect: this.$router.currentRoute.fullPath
								}
							})
						} catch (error) {
						   console.error('Error in then block:', error);
						}
						this.$IsConfirmExecute = false
					}).catch((err) => {
					   // 用户点击了取消按钮
						this.$IsConfirmExecute = false
						console.log("用户点击了取消按钮")
					});
					// 主动调用根组件的无障碍修复方法
					this.$root.set_message_input()
				},
			},
	};
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.template_box{
		width: 100%;
		height: 100%;
		padding: 0px 10px 10px 10px;
		border-top: 1px solid #f5f5f5;
	}
	.header{
		display: flex;
		padding: 15px 0px;
		.left_box{
			color: #06f;
			// color: #2094FA;
			font-size: 14px;
		}
		.right_box{
			display: flex;
			.menus{
				padding: 2px 8px;
				line-height: 1;
				cursor: pointer;
				border-right: 1px solid #666666;
				color: #666666;
				// color: #999999;
				&:last-child{
					border-right: 0px solid #666666;
				}
			}
			.active{
				color: #06f;
				// color: #2094FA;
			}
		}
	}
	.comment_item{
		padding: 15px 0px;
		cursor: pointer;
		border-bottom: 1px solid #f5f5f5;
		&:last-child{
			border-bottom: 0px solid #f5f5f5;
		}
	}
	.comment_item_header{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.left_box{
		display: flex;
		align-items: center;
		font-weight: 500;
		width: calc(100% - 60px);
		.avatar_pointer{
			cursor: pointer;
		}
		.avatar_default{
			cursor: default;
		}
		.avatar{
			width: 40px;
			height: 40px;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #505050;
			border-radius: 50%;
			overflow: hidden;
			img{
				width: 100%;
				height: 100%;
			}
			.el-icon-s-custom{
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				border: 1px #f5f5f5 solid;
				border-radius: 50%;
				font-size: 20px;
				color: #999;
			}
		}
		.comment_user_box{
			width: calc(100% - 55px);
			margin-left: 15px;
		}
		.comment_user_name{
			width: 100%;
			cursor: text;
			display: flex;
			flex-wrap: wrap;
			font-size: 14px;
		}
		.release_time{
			margin-top: 3px;
			font-size: 10px;
			color: #666666;
			// color: #999999;
		}
	}
	.right_box{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		align-items: center;
		width: 150px;
		margin-left: 10px;
	}
	.thumb_num{
		font-size: 12px;
		color: #06f;
		// color: #2094FA;
		cursor: default;
		margin-right: 0px;
	}
	.icon_box_img{
		cursor: pointer;
		width: 30px;
		height: 30px;
		img{
			width: 100%;
		}
	}
	
	.comment_content{
		margin-top: 15px;
		width: 100%;
		cursor: text;
		line-height: 1.5;
		font-weight: 500;
		/* display: flex;
		flex-wrap: wrap; */
		font-size: 12px;
	}
	.comment_reply{
		font-size: 12px;
		margin-top: 10px;
		cursor: pointer;
		color: #06f;
		// color: #2094FA;
		.el-icon-arrow-right{
			color: #06f;
			// color: #2094FA;
		}
	}
	.more_relative{
		height: 100%;
		margin-right: 15px;
		display: flex;
		align-items: center;
		cursor: pointer;
		position: relative;
		.margin_left{
			margin-left: 12px;
		}
		.choice_box{
			width: 200px;
			display: flex;
			flex-direction: column;
			position: absolute;
			right: 0;
			bottom: 0;
			margin-bottom: 20px;
			background-color: #f5f5f5;
			box-shadow: 0.5px 0.5px 0  0.5 #000000;
			padding: 5px 0px;
			z-index: 99;
			border-radius: 8px;
		}
		.choice_item{
			padding: 5px 10px;
			font-size: 14px;
			list-style: 1;
			&:hover{
				background-color: aliceblue;
			}
		}
	}
	@media screen and (min-width: 1024px) {
		
	}
	@media screen and (max-width: 1024px) {
		
	}
</style>
